import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { OverviewComponent } from './overview/overview.component';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { CreateProfileComponent } from '../create-profile/create-profile.component';
import { MatStepperModule, MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatSelectModule } from '@angular/material';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HttpClientModule } from '@angular/common/http';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { SharedModule } from 'src/app/shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccountComponent } from './account/account.component';
import { MatRadioModule } from '@angular/material/radio'; import { TagInputModule } from 'ngx-chips';
import { NzFormModule, NzGridModule, NzInputModule, NzButtonModule, NzRadioModule, NzSelectModule, NzDatePickerModule, NzCheckboxModule, NzTagModule, NzAlertModule, NzAutocompleteModule } from 'ng-zorro-antd';

@NgModule({
  declarations: [SidebarComponent, OverviewComponent, DashboardComponent, EditProfileComponent, CreateProfileComponent, AccountComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatStepperModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    AngularEditorModule,
    HttpClientModule,
    AngularFireStorageModule,
    SharedModule,
    PdfViewerModule,
    MatRadioModule,
    TagInputModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzButtonModule,
    NzRadioModule,
    NzSelectModule,
    NzDatePickerModule,
    NzCheckboxModule,
    NzTagModule,
    NzAlertModule,
    NzAutocompleteModule
  ]
})
export class DashboardModule { }
